
import { post, get, remove } from '../../utils/http'

export function newPayment(data) {
    return post('/payment/', data);
}

export function getPayments() {
    return get('/payment/');
}

export function cancelPayment(id, data) {
    return remove('/payment/' + id, data);
}
